import {Alert, Button, Card, Form, Input, message as antMessage, Popconfirm, Space, Spin, Typography} from 'antd';
import React from 'react';
import axios from '../../request/axios';

const {Text} = Typography;

class Renren extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            submitting: false
        };
    }

    componentDidMount() {
        this.setState({loading: true});
        axios.get('settings/renren').then(res => {
            const {data} = res.data;
            this.formRef && this.formRef.setFieldsValue(data);
        }).finally(() => {
            this.setState({loading: false});
        });
    }

    onFinish = (values) => {
        this.setState({form_submitting: true});
        axios.post('settings/renren', values).then(res => {
            const {code, message, data} = res.data;
            if (!code) {
                antMessage.success('修改成功');
            } else {
                antMessage.error(message);
            }
        }).finally(() => {
            this.setState({form_submitting: false});
        });
    };

    render() {
        return (
            <Card title='关联商城'>
                <Spin spinning={this.state.loading}>
                    <Form ref={ref => this.formRef = ref} labelCol={{span: 6}} wrapperCol={{span: 14}} onFinish={this.onFinish}>
                        <div className='mb-4'><Alert type='info' message={'输入您的商城网址，可以用来接收最新的商品调价、上下架信息'}/></div>
                        <Form.Item
                            label='商城网址'
                            name='mall_notice_url'
                        >
                            <Input style={{width: 200}}/>
                        </Form.Item>

                        <Form.Item wrapperCol={{
                            offset: 6,
                            span: 10
                        }}>
                            <Space>
                                <Button htmlType='submit' type='primary' loading={this.state.form_submitting}>保存</Button>
                            </Space>
                        </Form.Item>
                    </Form>
                </Spin>
            </Card>
        );
    }
}

export default Renren;
